class FiltersForm extends HTMLElement {
  constructor() {
    super();

    this.DEBOUNCE_DELAY = 500;

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.form = this.querySelector('[data-filters-form]');
    this.apply = this.querySelector('[data-filter-apply]');
    this.debouncedOnSubmit = debounce(
      (event) => this.onSubmitHandler(event),
      this.DEBOUNCE_DELAY,
    );
    this.form.addEventListener('input', this.debouncedOnSubmit.bind(this));
    this.form.addEventListener('change', this.debouncedOnSubmit.bind(this));

    this.addPriceFilterListener();
    this.addSortBySelectListener();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state
        ? event.state.searchParams
        : FiltersForm.searchParamsInitial;

      if (searchParams === FiltersForm.searchParamsPrev) return;

      FiltersForm.renderPage(searchParams, null, false);
    };

    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    const facets = document.querySelectorAll('[data-filters-refinements]');

    facets.forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FiltersForm.searchParamsPrev = searchParams;

    const sections = FiltersForm.getSections();

    sections.forEach((section) => {
      let url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;

      const filterDataUrl = (element) => element.url === url;

      FiltersForm.filterData.some(filterDataUrl)
        ? FiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        FiltersForm.filterData = [...FiltersForm.filterData, { html, url }];
        FiltersForm.renderFunctions(html, event);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FiltersForm.filterData.find(filterDataUrl).html;

    FiltersForm.renderFunctions(html, event);
  }

  static renderFunctions(html) {
    FiltersForm.renderFilters(html);
    FiltersForm.renderResultsContainer(html);
    FiltersForm.renderResultsCount(html);
    FiltersForm.renderActiveFacetsBar(html);
    FiltersForm.renderResultsHead(html);
    FiltersForm.renderPagination(html);
    window.swymCollectionsLoaded?.();

  }

  static renderResultsContainer(html) {
    let gridContainer = html.querySelector('[data-results-grid]');
    let newGridContainer = document.querySelector('[data-results-grid]');

    if (!newGridContainer) {
      const wrapper = document.querySelector('.results-grid__wrapper');
      if (wrapper) {
        newGridContainer = document.createElement('div');
        newGridContainer.className = 'results-grid__results';
        newGridContainer.setAttribute('data-results-grid', '');
        wrapper.appendChild(newGridContainer);
      } else {
        return;
      }
    }

    if (gridContainer) {
      newGridContainer.innerHTML = gridContainer.innerHTML;
    } else {
      newGridContainer.innerHTML = `<div class="results-grid__no-results" data-results-no-results><p>${window.generalStrings.gridNoResultsFound}</p></div>`;
    }
  }

  static renderResultsCount(html) {
    const count = html.querySelectorAll('[data-results-count]');
    const container = document.querySelectorAll('[data-results-count]');

    container.forEach((element, index) => {
      if (!count[index]) return;
      element.innerHTML = count[index].innerHTML;

      element.removeAttribute('hidden');
      const wrapper = element.closest('.results-grid__filters-trigger-count');
      if (wrapper) wrapper.removeAttribute('hidden');
    });
  }

  static renderResultsHead(html) {
    const headContainer = html.querySelector('.results-grid__head');
    const newHeadContainer = document.querySelector('.results-grid__head');

    if (!headContainer) return;

    if (!newHeadContainer) {
      const wrapper = document.querySelector('.results-grid__wrapper');
      if (wrapper) {
        const newHead = document.createElement('div');
        newHead.className = 'results-grid__head';
        newHead.innerHTML = headContainer.innerHTML;
        wrapper.insertBefore(newHead, wrapper.firstChild);
      }
    } else {
      newHeadContainer.innerHTML = headContainer.innerHTML;
    }
  }

  static renderFilters(html) {
    const filterOptions = html.querySelectorAll(
      '[data-filters-drawer] [data-filter]',
    );

    FiltersForm.renderDeviceFilters(filterOptions, 'drawer');
    FiltersForm.renderActiveFacets(html);
  }

  static renderDeviceFilters(filters, type = 'desktop') {
    const filtersArray = Array.from(filters);

    filtersArray.forEach((element) => {
      const index = element.dataset.index;
      const options = element.querySelector('[data-filter-options]');
      const target = document.querySelector(
        `[data-filters-${type}] [data-filter][data-index="${index}"]`,
      );
      const newOptions = target.querySelector('[data-filter-options]');

      if (options && newOptions) newOptions.innerHTML = options.innerHTML;
    });
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['[data-filters-refinements]'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      const newActiveFacetsElement = document.querySelector(selector);

      if (!activeFacetsElement || !newActiveFacetsElement) return;

      newActiveFacetsElement.innerHTML = activeFacetsElement.innerHTML;
    });

    FiltersForm.toggleActiveFacets(false);
  }

  static renderActiveFacetsBar(html) {
    const activeFacetsBar = html.querySelector('[data-active-filters]');
    const newActiveFacetsBar = document.querySelector('[data-active-filters]');

    if (activeFacetsBar && newActiveFacetsBar)
      newActiveFacetsBar.innerHTML = activeFacetsBar.innerHTML;
  }

  static renderPagination(html) {
    const pagination = html.querySelector('[data-pagination]');
    const newPagination = document.querySelector('[data-pagination]');
    const resultsSection = document.querySelector('[data-results-grid]');
    const resultsWrapper = document.querySelector('.results-grid__wrapper');

    if (newPagination && pagination)
      newPagination.replaceWith(pagination.cloneNode(true));
    if (newPagination && !pagination) newPagination.remove();
    if (!newPagination && pagination) {
      if (resultsSection) {
        resultsSection.insertAdjacentElement(
          'afterend',
          pagination.cloneNode(true),
        );
      } else if (resultsWrapper) {
        resultsWrapper.insertAdjacentElement(
          'beforeend',
          pagination.cloneNode(true),
        );
      }
    }
  }

  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      '',
      `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`,
    );
  }

  static getSections() {
    return [
      {
        section: document.querySelector('[data-results-grid]').dataset.section,
      },
    ];
  }

  addSyncInputListener(event, form) {
    const target = event.target;

    if (target.type === 'checkbox') {
      const name = target.name;
      const value = target.value;
      const allInputsWithSameNameAndValue = form.querySelectorAll(
        `input[name="${name}"][value="${value}"]`,
      );

      allInputsWithSameNameAndValue.forEach((input) => {
        if (input !== target) {
          input.checked = target.checked;
        }
      });
    }
  }

  addPriceFilterListener() {
    this.form.addEventListener('mousedown', (event) => {
      const input = event.target;
      if (
        input.type === 'radio' &&
        input.classList.contains('filter__input') &&
        input.checked
      ) {
        // Mark as about to be toggled off
        input.dataset.deselect = 'true';
      }
    });

    this.form.addEventListener('click', (event) => {
      const input = event.target;
      if (
        input.type === 'radio' &&
        input.classList.contains('filter__input') &&
        input.dataset.deselect === 'true'
      ) {
        // Deselect the radio
        input.checked = false;
        delete input.dataset.deselect;
        // Clear the price filter hidden fields
        const minHidden = this.form.querySelector('[data-price-filter-min]');
        const maxHidden = this.form.querySelector('[data-price-filter-max]');
        if (minHidden && maxHidden) {
          minHidden.value = '';
          maxHidden.value = '';
          minHidden.disabled = true;
          maxHidden.disabled = true;
        }
        // Prevent default form submission
        event.preventDefault();
        event.stopPropagation();
        // Trigger filter update
        this.onSubmitHandler(event);
        return;
      }
      if (input.dataset.deselect) {
        delete input.dataset.deselect;
      }
    });

    this.form.addEventListener('change', (event) => {
      const input = event.target;

      if (!input.dataset.min || !input.dataset.max) return;

      const minHidden = this.form.querySelector('[data-price-filter-min]');
      const maxHidden = this.form.querySelector('[data-price-filter-max]');

      if (!minHidden || !maxHidden) return;

      minHidden.disabled = false;
      maxHidden.disabled = false;
      minHidden.value = input.dataset.min;
      maxHidden.value = input.dataset.max;
    });
  }

  syncPriceFilterState() {
    const minHidden = this.form.querySelector('[data-price-filter-min]');
    const maxHidden = this.form.querySelector('[data-price-filter-max]');

    if (!minHidden || !maxHidden) return;

    const activePriceInput = this.form.querySelector(
      'input[name="price"]:checked',
    );

    minHidden.disabled = !activePriceInput;
    maxHidden.disabled = !activePriceInput;

    if (!activePriceInput) return;

    minHidden.value = activePriceInput.dataset.min || '';
    maxHidden.value = activePriceInput.dataset.max || '';
  }

  addSortBySelectListener() {
    document.addEventListener('change', (event) => {
      const select = event.target.closest('[data-filters-sort-select]');

    if (!select) return;

      const sortInput = document.querySelector('[data-sort-input]');

      if (!sortInput) return;

      sortInput.value = select.value;
      sortInput.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  createSearchParams(form) {
    const searchParams = new URLSearchParams();
    const elements = Array.from(form.elements);

    elements.forEach((element) => {
      if (!element.name || element.disabled) return;
      if (element.dataset.displayOnly === 'true') return;

      if (
        (element.type === 'checkbox' || element.type === 'radio') &&
        !element.checked
      ) {
        return;
      }

      searchParams.append(element.name, element.value);
    });

    return searchParams.toString();
  }

  onSubmitForm(searchParams, event) {
    FiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const form = document.querySelector('[data-filters-form]');

    this.addSyncInputListener(event, form);
    this.syncPriceFilterState();
    this.onSubmitForm(this.createSearchParams(form), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();

    FiltersForm.toggleActiveFacets();

    const href = event.target.href;

    let url = href.indexOf('?') === -1 ? '' : href.slice(href.indexOf('?') + 1);

    FiltersForm.renderPage(url);
  }
}

FiltersForm.filterData = [];
FiltersForm.searchParamsInitial = window.location.search.slice(1);
FiltersForm.searchParamsPrev = window.location.search.slice(1);
FiltersForm.setListeners();

class FilterRemove extends HTMLElement {
  constructor() {
    super();

    this.addListeners();
  }

  addListeners() {
    this.addEventListener('click', (event) => this.closeFilter(event));
    this.addEventListener('keyup', (event) => {
      if (event.code === 'Enter') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();

    const form =
      this.closest('[data-filters]') || document.querySelector('filters-form');

    if (form) form.onActiveFilterClick(event);
  }
}

customElements.define('filters-form', FiltersForm);
customElements.define('filter-remove', FilterRemove);
